import * as ngSelectOptionHighlight from '@ng-select/ng-option-highlight';

if(window['ng-select'] == null) window['ng-select'] = {};
window['ng-select']['ng-option-highlight'] = ngSelectOptionHighlight

export { ngSelectOptionHighlight };